import React from "react";
// Date and Time Picker Popover

// Mui
import Popover from "@mui/material/Popover";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";

// Custom
import CustomTimePicker from "../timePicker/TimePicker-New";
import CustomDatePicker from "../datePicker/DatePicker";
import ContainedButton from "../../forms/button/ContainedButton";

// Utils
import { formatDate } from "../../utils/helper";

const DateAndTimePopover = ({
  anchorEl,
  setAnchorEl,
  startDate = new Date(),
  endDate = new Date(),
  handleDateChange,
  timeRange = [0, 1439],
  setTimeRange,
  handleDateSubmit,
  btnText,
}: {
  anchorEl: HTMLElement | null;
  setAnchorEl: (anchorEl: HTMLElement | null) => void;
  startDate: Date;
  endDate: Date;
  handleDateChange: (dates: [Date, Date]) => void;
  timeRange?: number[];
  setTimeRange: (timeRange: number | number[]) => void;
  handleDateSubmit: () => void;
  btnText?: string;
}) => {
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      slotProps={{ paper: { sx: { bgcolor: "#FAFAFA" } } }}
    >
      <Stack
        direction={"row"}
        justifyContent={"center"}
        gap={"5px"}
        alignItems={"center"}
        padding={"20px"}
      >
        <Typography>
          {formatDate(startDate, "D MMMM YYYY", "Asia/Kolkata")} -{" "}
        </Typography>
        <Typography>
          {formatDate(endDate, "D MMMM YYYY", "Asia/Kolkata")}
        </Typography>
      </Stack>

      <Divider />

      <CustomDatePicker
        startDate={startDate}
        endDate={endDate}
        onChange={(dates) => handleDateChange(dates)}
      />

      <CustomTimePicker timeRange={timeRange} setTimeRange={setTimeRange} />

      <Box p={"10px"} display={"flex"} gap={1}>
        <ContainedButton
          label="Cancel"
          variant="outlined"
          bgColor="transparent"
          sx={{ borderColor: "#00000050", color: "black", width: "30%" }}
          hoverBgColor="#00000010"
        />
        <ContainedButton
          label={btnText || "Done"}
          sx={{
            width: "100%",
            fontWeight: 600,
            color: "#ffffff",
            padding: "12px 15px",
            boxShadow: "0",
          }}
          onClick={() => {
            handleDateSubmit();
            handleClose();
          }}
        />
      </Box>
    </Popover>
  );
};

export default DateAndTimePopover;
